const accordion = (triggerList: HTMLButtonElement[]) => {
	type AccordionState = {
		trigger: HTMLButtonElement;
		panel: HTMLElement;
		isAnimating: boolean;
	};

	const keyframeEffectOption: KeyframeAnimationOptions = {
		duration: 300,
		easing: "ease",
		fill: "both",
	};

	function openPanel(state: AccordionState) {

		const { trigger, panel } = state;
		state.isAnimating = true;
		trigger.setAttribute("aria-expanded", "true");
		panel.removeAttribute("inert");
		console.log({ panel });
		panel.hidden = false;
		panel.style.height = "0px";
		const endH = panel.scrollHeight;
		const anim = panel.animate(
			[{ height: "0px" }, { height: `${endH}px` }],
			keyframeEffectOption,
		);
		anim.onfinish = () => {
			panel.style.height = "auto";
			state.isAnimating = false;
		};
	}

	function closePanel(state: AccordionState) {
		const { trigger, panel } = state;
		state.isAnimating = true;
		const startH = panel.scrollHeight;
		const anim = panel.animate(
			[{ height: `${startH}px` }, { height: "0px" }],
			keyframeEffectOption,
		);
		trigger.setAttribute("aria-expanded", "false");
		panel.setAttribute("inert", "");
		anim.onfinish = () => {
			panel.hidden = true;
			panel.style.height = "";
			state.isAnimating = false;
		};
	}

	triggerList.forEach((trigger) => {
		const panelId = trigger.getAttribute("aria-controls") || "";
		const panel = document.getElementById(panelId);

		if (!panel) return;

		const state: AccordionState = { trigger, panel, isAnimating: false };

		trigger.addEventListener("click", (event) => {
			if (
				!(event instanceof MouseEvent) ||
				event.button !== 0 ||
				state.isAnimating
			) {
				return;
			}
			event.preventDefault();

			const isOpen = trigger.getAttribute("aria-expanded") === "true";
			if (isOpen) {
				closePanel(state);
			} else {
				openPanel(state);
			}
		});
	});
};
export default accordion;
